import { AffiliateView } from 'features/AffiliateView';

const AffiliateViewPage = (): JSX.Element => {
	return <AffiliateView />;
};

export default AffiliateViewPage;
